import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const PopupSurveyPicker = lazy(() =>
  import(/* webpackChunkName: "PopupSurveyPicker" */ '../../components/survey_explorer/LoadPopupSurveyPicker')
);

export default function PopupSurveyPickerComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <PopupSurveyPicker {...props} />
    </Suspense>
  );
}
